var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 86.304 c -0.459 0 -0.919 -0.105 -1.342 -0.316 C 12.259 70.287 0.527 47.557 0.019 31.52 C -0.325 20.69 4.171 11.488 12.045 6.905 C 20.918 1.743 32.568 2.841 45 9.968 c 12.432 -7.127 24.085 -8.225 32.955 -3.063 c 7.874 4.583 12.369 13.785 12.026 24.615 c -0.509 16.037 -12.24 38.768 -43.64 54.468 C 45.919 86.198 45.46 86.304 45 86.304 z M 24.426 9.698 c -3.46 0 -6.615 0.793 -9.363 2.393 c -6.026 3.507 -9.324 10.52 -9.047 19.239 C 6.462 45.415 16.968 65.466 45 79.939 C 73.032 65.466 83.537 45.415 83.984 31.33 c 0.276 -8.719 -3.021 -15.732 -9.048 -19.239 c -7.25 -4.219 -17.325 -2.825 -28.373 3.924 c -0.959 0.587 -2.167 0.587 -3.127 0 C 36.577 11.824 30.092 9.698 24.426 9.698 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.7c5e245b8014e237d39c09c06f133b13.svg";
export { ForwardRef as ReactComponent };